import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  cancelCrashBetService, escapeCrashBetService, getAllRoundHistoryService,
  getMyBetsService, verifyProvableFairCrashService, getTopBetsService, placeBetCrashGameService, getPreviousRoundBetsService,
  CrashCheckFairness
} from 'network/services/crashGame.service'
import { appendCurrentBetsToMyBets, setCurrentPlacedBet, setPlacedCrashBetId, setPlacingOrCashoutLoading } from 'redux-store/redux/slices/crashGame.slice'
import { openErrorToaster } from 'utils/common-services/toaster.service'
// import { openSuccessToaster } from 'utils/common-services/toaster.service'
import { APPEND_TYPES } from 'utils/constants/index'

export const placedBetCrashGame = createAsyncThunk('crash-game/place-bet', async ({ payload, id, onSuccess }, thunkApi) => {
  try {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: true }))
    const res = await placeBetCrashGameService(payload)
    onSuccess()
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: res.id, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: res, reset: false }))
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return res
  } catch (error) {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const escapeCrashBet = createAsyncThunk('crash-game/player-escape', async ({ betId, id, onSuccess }, thunkApi) => {
  try {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: true }))
    const res = await escapeCrashBetService({ betId })
    // onSuccess()
    // const store = thunkApi.getState()
    // if (store?.crashGame?.myBetsData) {
    //   const state = store?.crashGame
    //   const escapedBet = [res]
    //   const betExist = state?.myBetsData?.crashGameBets?.some(bet => bet?.id === escapedBet?.[0]?.id)
    //   if (!betExist) {
    //     openSuccessToaster({ message: `You win Odds : ${res?.escapeRate} Coins :${res?.winningAmount.toFixed(2)}` })
    //   }
    // }
    thunkApi.dispatch(appendCurrentBetsToMyBets({ type: APPEND_TYPES.ESCAPE, data: [res] }))
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: null, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: null, reset: false }))
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return res
  } catch (error) {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const cancelCrashBet = createAsyncThunk('crash-game/cancel-bet', async ({ id, betId, onSuccess }, thunkApi) => {
  try {
    const res = await cancelCrashBetService({ betId })
    onSuccess()
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: null, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: null, reset: false }))
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].name })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getAllRoundHistory = createAsyncThunk('crash-game/get-history', async (_, thunkApi) => {
  try {
    const res = await getAllRoundHistoryService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyBets = createAsyncThunk('crash-game/my-bets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyBetsPaginated = createAsyncThunk('crash-game/my-bets-paginated', async (params, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

// not used
export const getPreviousRoundBets = createAsyncThunk('crash-game/previous-round-placed-bets', async (params, thunkApi) => {
  try {
    const res = await getPreviousRoundBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

// not used
export const verifyProvableFairCrash = createAsyncThunk('crash-game/check-provable-fair', async ({ payload }, thunkApi) => {
  try {
    const res = await verifyProvableFairCrashService(payload)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
export const getTopBets = createAsyncThunk('crash-game/top-bets', async (params, thunkApi) => {
  try {
    const res = await getTopBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const checkFairnessCrashGame = createAsyncThunk('crash-game/check-fairness', async (payload, thunkApi) => {
  try {
    const res = await CrashCheckFairness(payload)
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})
